import React from "react";
import "./assets/scss/index.scss";
import Header from "./components/Header";
import Navbar from "./components/Navbar/Navbar";

function App() {
  return (
    <div className="coming-soon d-flex align-items-center p-4 p-sm-5">
      {/* <Header /> */}
      {/* <Navbar /> */}
      <div>
        <h1 className="text-white fade-in-bottom">Coming Soon.</h1>
        <p className="font-weight-light text-white fade-in-bottom">
          I’m currenly updating my portfolio to include previous projects. If it
          happens you really need to see my craft you can email me for the mean
          time.
        </p>
        <div className="fade-in-bottom">
          Notify me via{" "}
          <a href="mailto:sam.tags@protonmail.ch" className="font-weight-bold">
            email.
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
